var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwipeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 6,
    viewBox: "0 0 24 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0L23.3415 4.08052C23.8605 4.26725 24.1283 4.83493 23.9395 5.34846C23.7508 5.86198 23.177 6.1269 22.658 5.94016L12 2.10555L1.34198 5.94016C0.822963 6.1269 0.249213 5.86198 0.0604774 5.34846C-0.128258 4.83493 0.139492 4.26725 0.658514 4.08052L12 0Z",
    fill: "#D4CEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeUp);
export default __webpack_public_path__ + "static/media/swipe-up.001028d5ce7d0a1083c1e9580f93caa3.svg";
export { ForwardRef as ReactComponent };